import Button, { type ButtonProps } from '@mui/material/Button';
import React from 'react';

interface SubmitProps extends ButtonProps {
  submitting?: boolean;
}

const Submit = React.forwardRef<HTMLButtonElement, SubmitProps>(
  (props, ref) => {
    const { submitting = false, children = 'Submit', ...restProps } = props;
    return (
      <Button ref={ref} type="submit" loading={submitting} {...restProps}>
        {children}
      </Button>
    );
  },
);

Submit.displayName = 'Submit';
export default Submit;
